//@ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ClearIcon } from 'sharedComponents/Icons';
import Form from '../Form/Form';

const styles = (theme) => ({
  clearButton: {
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& svg': {
      height: 20,
      width: 20,
      fill: theme.color.grey_dark,
    },
  },
});

const FormTextInput = ({ name, label, disabled, onClear, showClearButton, classes, placeholder }) => {
  const renderInputClearButton = () => {
    return showClearButton ? (
      <IconButton
        // @ts-ignore
        onClick={onClear}
        classes={{ root: classes?.clearButton }}
        data-testid="search-field-clear-value"
      >
        <ClearIcon />
      </IconButton>
    ) : null;
  };

  return (
    <Form.Input
      name={name}
      label={label}
      disabled={disabled}
      placeholder={placeholder}
      InputProps={{
        endAdornment: renderInputClearButton(),
      }}
    />
  );
};

FormTextInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onClear: PropTypes.func,
  showClearButton: PropTypes.bool,
  placeholder: PropTypes.string,
};

FormTextInput.defaultProps = {
  name: '',
  label: '',
  onClear: () => {},
  showClearButton: false,
  placeholder: '',
};

export default withStyles(styles)(FormTextInput);
